import React, { Component } from 'react'
import { changePasswRecruiterUser, resetPasswRecruiterUser } from '../../action/auth'
import ChangePasswords from '../../old_Components/ChangePassword/ChangePassword'
import Swal from 'sweetalert2'
import queryString from 'query-string';
import constant from '../../constant';
export default class ChangePassword extends Component {


    onSubmit = (model) => {
        const qParam = queryString.parse(this.props?.location?.search)
        // console.log(qParam)
        // model.t = qParam.t
        model.e = qParam.e
        console.log(model)
     
        changePasswRecruiterUser(model).then(res => {
            debugger
            if (res.status) {
                Swal.fire({
                    icon: 'success',
                    text: 'Password Change Successfully',
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
                this.props.history.push(constant.component.Dashboard.url)
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
            
        }).catch(err => {
            Swal.fire({
                icon: 'error',
                text: err,
                timer: 1500,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }
    render() {
        return (
            <React.Fragment>
                <ChangePasswords 
                onSubmit={this.onSubmit}
                />
            </React.Fragment>
        )
    }
}
